// src/pages/NotificationManagement.js
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import colors from "../Constants/colors";

const NotificationManagement = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const cardStyle = {
    background: "#ffffff",
    padding: "20px",
    borderRadius: "14px",
    boxShadow: `0 4px 12px ${colors.cardShadow}`,
    display: "flex",
    alignItems: "center",
    gap: "16px",
    minHeight: "120px",
    transition: "0.3s",
  };

  const iconStyle = {
    fontSize: "36px",
    flexShrink: 0,
  };

  const heading = {
    fontSize: "18px",
    fontWeight: "600",
    color: colors.grayDark,
    marginBottom: "4px",
  };

  const subText = {
    fontSize: "12px",
    color: colors.grayDark,
    opacity: 0.85,
  };

  const titleStyle = {
    fontWeight: "700",
    color: colors.grayDark,
  };

  const notificationCards = [
    {
      title: "Add Notification",
      description: "Create a new notification for your class.",
      icon: "fa-bell",
      color: "#3B82F6",
      link: "/add-notification",
    },
    {
      title: "View Notifications",
      description: "See all notifications for your class.",
      icon: "fa-eye",
      color: "#10B981",
      link: "/view-notification",
    },
    {
      title: "Student Achievements",
      description: "View achievements of your students.",
      icon: "fa-trophy",
      color: "#FBBF24",
      link: "/student-achievements",
    },
  ];

  return (
    <div className="bg-white min-h-screen p-6">
      <div className="max-w-7xl mx-auto">


        {/* Grid */}
        <div
          className={`grid gap-6 ${
            isMobile ? "grid-cols-1" : "sm:grid-cols-2 lg:grid-cols-3"
          }`}
        >
          {notificationCards.map((card, idx) => (
            <Link to={card.link} key={idx}>
              <div style={cardStyle} className="hover:scale-[1.02] transition">

                {/* Icon */}
                <i
                  className={`fas ${card.icon}`}
                  style={{
                    ...iconStyle,
                    color: card.color,
                  }}
                ></i>

                {/* Title + Desc */}
                <div>
                  <h2 style={heading}>{card.title}</h2>
                  <p style={subText}>{card.description}</p>
                </div>

              </div>
            </Link>
          ))}
        </div>

      </div>
    </div>
  );
};

export default NotificationManagement;
